// Generated by purs version 0.11.7
"use strict";
var Data_Either = require("../Data.Either");
var Data_Lens_Prism = require("../Data.Lens.Prism");
var Data_Profunctor_Choice = require("../Data.Profunctor.Choice");
var _Right = function (dictChoice) {
    return Data_Profunctor_Choice.right(dictChoice);
};
var _Left = function (dictChoice) {
    return Data_Profunctor_Choice.left(dictChoice);
};
module.exports = {
    _Left: _Left,
    _Right: _Right
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Prism.Either/index.js
// module id = 553
// module chunks = 0